import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DataItemType } from '@cloudpivot/form/schema';
let FilterCard = class FilterCard extends Vue {
    get sourceSingle() {
        return this.source[0];
    }
    get isChinese() {
        return this.$i18n.locale === 'zh';
    }
    contentHandler(type) {
        if (type === -2) {
            return this.sourceSingle.content[this.$i18n.locale];
        }
        else if (type === -10) {
            return this.isChinese ? this.sourceSingle.content.name : this.sourceSingle.content.name_i18n[this.$i18n.locale];
        }
        else {
            return this.getContent(this.sourceSingle.content, this.sourceSingle.type);
        }
    }
    getContent(content, type) {
        switch (type) {
            case DataItemType.StaffSelector:
                const c = JSON.parse(content)[0];
                return c.name;
            case DataItemType.Address:
                const address = JSON.parse(content);
                return `${address.provinceName}${address.cityName}${address.districtName}`;
            case DataItemType.Number:
                return content.split(';').join('-');
            case DataItemType.Date:
            case DataItemType.Time:
                return content.split(';').join('-');
            case DataItemType.RelevanceForm:
                try {
                    const _address = JSON.parse(content);
                    if (_address.provinceName || _address.cityName || _address.districtName) {
                        // 确保是关联的是地址
                        return `${_address.provinceName}${_address.cityName}${_address.districtName}`;
                    }
                    return content;
                }
                catch (err) {
                    return content;
                }
            default:
                return content;
        }
    }
    clear() {
        this.$emit('clear');
    }
    itemClick() {
        this.$emit('item-click');
    }
    created() {
        console.log('filter card 1231231');
    }
};
tslib_1.__decorate([
    Prop()
], FilterCard.prototype, "source", void 0);
FilterCard = tslib_1.__decorate([
    Component({
        name: "FilterCard",
    })
], FilterCard);
export default FilterCard;
